export const REPORTING_LEVEL_DIRECT = 'direct';
export const REPORTING_LEVEL_DIRECT_AND_INDIRECT = 'direct_and_indirect';

export const ADMIN_DASHBOARD = 'dashboard';
export const ADMIN_DOCUMENTS = 'documents';
export const ADMIN_GENERAL_PLATFORM = 'general';
export const ADMIN_GROUP_PAGE = 'groups';
export const ADMIN_OUTBOX = 'emails';
export const ADMIN_PENDING_HIRES = 'pendingHires';
export const ADMIN_PERMISSIONS = 'permissions';
export const ADMIN_PROFILE_SETUP = 'records';
export const ADMIN_REPORTS = 'reports';
export const ADMIN_TIME_OFF = 'timeOff';
export const ADMIN_TIME_OFF_PAYWALL = 'timeOffPaywall';
export const ADMIN_WORKFLOWS = 'tasks';
export const ADMIN_INTEGRATIONS = 'integrations';

export const PLATFORM_CALENDAR = 'calendar';
export const PLATFORM_DOCUMENTS = 'document';
export const PLATFORM_ORG_CHART = 'orgChart';
export const PLATFORM_PEOPLE = 'people';
export const PLATFORM_PROFILE_INFO = 'profileInfo';
export const PLATFORM_TASKS = 'task';
export const PLATFORM_TEAM = 'team';
export const PLATFORM_TIME_OFF = 'timeOff';
export const PLATFORM_UPDATES = 'updates';
export const PLATFORM_FULL_TIME_EQUIVALENT = 'full-time-equivalent';
export const PLATFORM_SICKNESS_REPORTING = 'sickness-reporting';
export const OLD_TIME_OFF = 'oldTimeoff';

export const RECORD_ADDITIONAL_INFO = 'additionalInfo';
export const RECORD_PERSONAL_INFO = 'personalInfo';
export const RECORD_PRIVATE_INFO = 'privateInfo';

export const OVERALL_ROLE = 'role';
export const OVERALL_TABLE = 'table';
export const OVERALL_TEAM = 'team';

export const PERMISSION_NO_ACCESS = 'no_access';
export const PERMISSION_VIEW_AND_EDIT = 'view_and_edit';
export const PERMISSION_VIEW_AND_EDIT_CUSTOM = 'viewAndEdit';
export const PERMISSION_VIEW_ONLY = 'view_only';
export const PERMISSION_VIEW_ONLY_CUSTOM = 'view';

export const NEGLECTED_STAGES = ['incomplete', 'last_week', 'departed', 'offboarding', 'last_month'];
